'use client'
import { useMemo } from 'react'

import { RaHeading, RaImage, RaTypography } from '@components/core/index.core'
import { AcfTravelExpertsSingleExpert } from '@typings'

export const RaTravelGuides = ({
  travelplan_expert,
}: {
  travelplan_expert: AcfTravelExpertsSingleExpert
}) => {
  const polaroidContent = useMemo(() => {
    if (!travelplan_expert?.job_title) return null
    return (
      <>
        <RaHeading
          noPadding
          component="h4">
          {travelplan_expert.job_title}
        </RaHeading>
        <RaTypography
          component="span"
          align="center">
          {travelplan_expert.name}
        </RaTypography>
      </>
    )
  }, [travelplan_expert])

  if (!travelplan_expert) return null

  return (
    <RaImage
      image={travelplan_expert.image}
      polaroid
      polaroidContent={polaroidContent}
      rotate="right"
    />
  )
}
